import React, {useState} from "react";
import imageCarne from "@/assets/1 Carne.jpg";
import imageLactate from "@/assets/2 Lactate.jpg";
import imageBauturiAlcoolice from "@/assets/5 Bauturi cu alcool.jpg";
import imageIgienaCasei from "@/assets/6 Detergenti igienizarea casei.jpg";
import imageFrumusete from "@/assets/7 Frumusete.jpg";
import imageTextile from "@/assets/12 Textile.jpg";
import imageServiciiComp from "@/assets/14 Servicii complementare.jpg";
import imageBrutarie from "@/assets/22 Brutarie patiserie cofetarie.jpg";
import imageGastro from "@/assets/23 Gastro.jpg";
import imageFructeLegume from "@/assets/25 Fructe si legume.jpg";
import imageBranzeturi from "@/assets/27 Branzeturi.jpg";
import imageMezeluri from "@/assets/28 Mezeluri.jpg";
import imageCongelate from "@/assets/29 Congelate.jpg";
import imageSarate from "@/assets/30 Sarate.jpg";
import imageDulciuri from "@/assets/31 Dulciuri.jpg";
import imageBauturiNonAlcoolice from "@/assets/34 Bauturi fara alcool.jpg";
import imageAlimentSpeciala from "@/assets/37 Alimentatie speciala.jpg";
import imageAnimalier from "@/assets/37 Animalier.jpg";
import imageBebe from "@/assets/38 Bebe.jpg";
import imageMenaj from "@/assets/41 Menaj.jpg";
import imageAuto from "@/assets/42 Auto brico.jpg";
import imageCultura from "@/assets/43 Cultura jocuri jucarii.jpg";
import imageActivitati from "@/assets/44 Activitati exterioare.jpg";
import imagePeste from "@/assets/3 Peste.png";
import imageServicii from "@/assets/Piata 49 SERVICII.jpg";
import imageElectrocasnice from "@/assets/Piata 11 ELECTROCASNICE.jpg";
import imageElectronice from "@/assets/Piata 9 ELECTRONICE,MULTIMEDIA.jpg";

function Category() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  
  const toggleDropdown = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const categories = [
    // {
    //   id: 1,
    //   name: "PRODUSE AUCHAN",
    //   image: imageProduseAuchan,
    //   localMarketId: 6,
    // },
    {
      id: 2,
      name: "GASTRO",
      image: imageGastro,
      localMarketId: 23,
      subcategories: [
        {
          segmentId: 707,
          segmentName: "Gastro Productie Proprie"
        },
        {
          segmentId: 708,
          segmentName: "Gastro Semipreparate"
        },
      ]
    },
    {
      id: 3,
      name: "CARNE",
      image: imageCarne,
      localMarketId: 1,
      subcategories: [
        {
          segmentId: 115,
          segmentName: "Carmangerie"
        },
        {
          segmentId: 120,
          segmentName: "Pasare"
        },
        {
          segmentId: 125,
          segmentName: "Carne Congelata"
        }
      ]
    },
    {
      id: 4,
      name: "BRANZETURI",
      image: imageBranzeturi,
      localMarketId: 27,
      subcategories: [
        {
          segmentId: 718,
          segmentName: "Branzeturi cu Servire"
        },
        {
          segmentId: 719,
          segmentName: "Branzeturi cu Autoservire"
        },
      ]
    },
    {
      id: 5,
      name: "CONGELATE",
      image: imageCongelate,
      localMarketId: 29,
      subcategories: [
        {
          segmentId: 723,
          segmentName: "Inghetata Desert Congelat"
        },
        {
          segmentId: 724,
          segmentName: "Semipreparate Congelate"
        },
      ]
    },
    {
      id: 6,
      name: "PESTE",
      image: imagePeste,
      localMarketId: 3,
      subcategories: [
        {
          segmentId: 240,
          segmentName: "Peste Proaspat"
        },
        {
          segmentId: 245,
          segmentName: "Peste Procesat"
        },
      ]
    },
    {
      id: 7,
      name: "SARATE",
      image: imageSarate,
      localMarketId: 30,
      subcategories: [
        {
          segmentId: 704,
          segmentName: "Panificatie Prod Proprie"
        },
        {
          segmentId: 705,
          segmentName: "Patiserie Prod Proprie"
        },
        {
          segmentId: 706,
          segmentName: "Cofetarie Prod Proprie"
        },
      ]
    },
    {
      id: 8,
      name: "LACTATE",
      image: imageLactate,
      localMarketId: 2,
      subcategories: [
        {
          segmentId: 155,
          segmentName: "Unt si Margarina"
        },
        {
          segmentId: 160,
          segmentName: "Iaurt si Desert"
        },
        {
          segmentId: 165,
          segmentName: "Oua"
        },
        {
          segmentId: 170,
          segmentName: "Lactate UHT"
        },
        {
          segmentId: 817,
          segmentName: "Lactate Ultraproaspete"
        }
      ]
    },
    {
      id: 9,
      name: "MEZELURI",
      image: imageMezeluri,
      localMarketId: 28,
      subcategories: [
        {
          segmentId: 720,
          segmentName: "Masline si Antipasti"
        },
        {
          segmentId: 721,
          segmentName: "Mezeluri Stand cu Servire"
        },
        {
          segmentId: 722,
          segmentName: "Mezeluri Autoservire"
        },
      ]
    },
    {
      id: 10,
      name: "FRUCTE SI LEGUME",
      image: imageFructeLegume,
      localMarketId: 25,
      subcategories: [
        {
          segmentId: 711,
          segmentName: "Legume Proaspete"
        },
        {
          segmentId: 712,
          segmentName: "Fructe Proaspete"
        },
      ]
    },
    {
      id: 11,
      name: "BAUTURI FARA ALCOOL",
      image: imageBauturiNonAlcoolice,
      localMarketId: 34,
      subcategories: [
        {
          segmentId: 739,
          segmentName: "Apa"
        },
        {
          segmentId: 740,
          segmentName: "Bauturi Necarbo si Sirop"
        },
        {
          segmentId: 741,
          segmentName: "Bauturi Carbonatate"
        }
      ]
    },
    {
      id: 12,
      name: "DULCIURI",
      image: imageDulciuri,
      localMarketId: 31,
      subcategories: [
        {
          segmentId: 730,
          segmentName: "Desert"
        },
        {
          segmentId: 731,
          segmentName: "Biscuiti Patiserie"
        },
        {
          segmentId: 732,
          segmentName: "Mic Dejun"
        },
        {
          segmentId: 733,
          segmentName: "Bauturi Calde"
        },
        {
          segmentId: 734,
          segmentName: "Bomboane si Ciocolata"
        },
      ],

    },
    {
      id: 13,
      name: "ALIMENTATIE SPECIALA",
      image: imageAlimentSpeciala,
      localMarketId: 32,
      subcategories: [
        {
          segmentId: 737,
          segmentName: "Specialit Internationale"
        },
      ]
    },
    {
      id: 14,
      name: "FRUMUSETE",
      image: imageFrumusete,
      localMarketId: 7,
      subcategories: [
        {
          segmentId: 395,
          segmentName: "Frumusete"
        },
        {
          segmentId: 400,
          segmentName: "Intretinere Par"
        },
        {
          segmentId: 405,
          segmentName: "Igiena"
        },
        {
          segmentId: 410,
          segmentName: "Machiaj"
        }
      ]
    },
    {
      id: 15,
      name: "BAUTURI CU ALCOOL",
      image: imageBauturiAlcoolice,
      localMarketId: 5,
      subcategories: [
        {
          segmentId: 340,
          segmentName: "Bauturi Spirtoase"
        },
        {
          segmentId: 345,
          segmentName: "Bere"
        },
        {
          segmentId: 355,
          segmentName: "Vin"
        }
      ]
    },
    {
      id: 16,
      name: "BRUTARIE PATISERIE COFETARIE",
      image: imageBrutarie,
      localMarketId: 22,
      subcategories: [
        {
          segmentId: 725,
          segmentName: "Garnituri"
        },
        {
          segmentId: 726,
          segmentName: "Conserve"
        },
        {
          segmentId: 727,
          segmentName: "Condimente si Sosuri"
        },
        {
          segmentId: 728,
          segmentName: "Ulei si Otet"
        },
        {
          segmentId: 729,
          segmentName: "Aperitiv Sarat"
        },
      ]
    },
    {
      id: 17,
      name: "ANIMALIER",
      image: imageAnimalier,
      localMarketId: 37,
      subcategories: [
        {
          segmentId: 746,
          segmentName: "Animalier"
        },
      ]
    },
    {
      id: 18,
      name: "DETERGENTI IGIENIZAREA CASEI",
      image: imageIgienaCasei,
      localMarketId: 6,
      subcategories: [
        {
          segmentId: 385,
          segmentName: "Spalare/Intretinere"
        },
        {
          segmentId: 390,
          segmentName: "Igienizarea Casei"
        },
        {
          segmentId: 851,
          segmentName: "Hartie Uz Casnic"
        }
      ]
    },
    {
      id: 19,
      name: "BEBE",
      image: imageBebe,
      localMarketId: 38,
      subcategories: [
        {
          segmentId: 747,
          segmentName: "Alimente Bebelusi"
        },
        {
          segmentId: 748,
          segmentName: "Igiena Bebe"
        },
      ]
    },
    {
      id: 20,
      name: "MENAJ",
      image: imageMenaj,
      localMarketId: 41,
      subcategories: [
        {
          segmentId: 757,
          segmentName: "Curatenia si Intret Casei"
        },
        {
          segmentId: 758,
          segmentName: "Decorarea Casei"
        },
        {
          segmentId: 759,
          segmentName: "Aranjarea Mesei"
        },
        {
          segmentId: 760,
          segmentName: "Articole de Gatit"
        },
      ]
    },
    {
      id: 21,
      name: "CULTURA JOCURI JUCARII",
      image: imageCultura,
      localMarketId: 43,
      subcategories: [
        {
          segmentId: 763,
          segmentName: "Papetarie"
        },
      ]
    },
    {
      id: 22,
      name: "TEXTILE",
      image: imageTextile,
      localMarketId: 12,
      subcategories: [
        {
          segmentId: 534,
          segmentName: "Lenjerie Barbati"
        },
        {
          segmentId: 535,
          segmentName: "Lenjerie Femei"
        },
      ]
    },
    {
      id: 23,
      name: "AUTO BRICO",
      image: imageAuto,
      localMarketId: 42,
      subcategories: [
        {
          segmentId: 761,
          segmentName: "Auto"
        },
        {
          segmentId: 762,
          segmentName: "Bricolaj"
        },
      ]
    },
    {
      id: 24,
      name: "ACTIVITATI EXTERIOARE",
      image: imageActivitati,
      localMarketId: 44,
      subcategories: [
        {
          segmentId: 766,
          segmentName: "Gradina"
        },
      ]
    },
    {
      id: 25,
      name: "SACOSE",
      image: imageServiciiComp,
      localMarketId: 14,
      subcategories: [
        {
          segmentId: 671,
          segmentName: "Sacose"
        },
      ]
    },
    {
      id: 26,
      name: "ELECTRONICE MULTIMEDIA",
      image: imageElectronice,
      localMarketId: 9,
      subcategories: [
        {
          segmentId: 482,
          segmentName: "Sunet"
        },
        {
          segmentId: 483,
          segmentName: "Accesorii Imagine/Sunet"
        },
        {
          segmentId: 486,
          segmentName: "IT Accesorii"
        },
        {
          segmentId: 487,
          segmentName: "Foto"
        },
        {
          segmentId: 488,
          segmentName: "Telefonie"
        },
      ]
    },
    {
      id: 26,
      name: "ELECTROCASNICE",
      image: imageElectrocasnice,
      localMarketId: 11,
      subcategories: [
        {
          segmentId: 526,
          segmentName: "Electrocasnice mari"
        },
        {
          segmentId: 527,
          segmentName: "Electrocasnice mici"
        },
      ]
    },
    {
      id: 27,
      name: "SERVICII",
      image: imageServicii,
      localMarketId: 49,
      subcategories: [
       
      ]
    },
  ];
  return (
      <>
        <div className="max-w-[1640px] m-auto px-4 py-12">
          <div className="flex flex-col items-center">
            <h1 className="text-red-600 font-bold text-4xl text-center mb-3">
              Bine ai venit!
            </h1>
            <h2 className="text-xl font-bold text-gray-900 my-3 sm:text-3xl">
              Categorii recomandate
            </h2>
          </div>

          <div className="">
            <div className="flex items-center justify-center my-0.5 py-0.5">
              <div
                  className="grid grid-cols-2 lg:grid-cols-5 place-items-left gap-1 py-3 md:px-6 w-4/5">

                {categories.map((item, index) => (

                    index < 10 && (
                        <div key={index} style={{position: 'relative'}} className="mx-1 md:mx-2">
                          <a href={"/category/" + item.localMarketId}>
                            <button
                                id={`dropdownAvatarNameButton-${item.id}`}
                                onClick={() => toggleDropdown(index)}
                                className="flex items-center text-sm text-left pe-1 font-medium text-gray-900 rounded-full hover:text-red-600 dark:hover:text-red-500 md:me-0 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:text-white"
                                type="button"
                                style={{zIndex: 1}}
                            >
                              <span className="sr-only">Open user menu</span>
                              <img className="w-12 h-12 me-2 rounded-full" src={item.image} alt={item.name}/>
                              {item.name}
                            </button>
                          </a>
                        </div>
                    )
                ))}
              </div>
            </div>
            <hr className="h-px mx-24 bg-gray-300 border-0 rounded dark:bg-gray-700"></hr>

            <div className="flex items-center justify-center my-0.5 py-0.5">
              <div className="grid grid-cols-2 lg:grid-cols-4 place-items-left gap-1 py-3 md:px-6 w-3/4">
                {categories.map((item, index) => (

                    index > 9 && index < 18 && (
                        <div key={index} style={{position: 'relative'}} className="mx-1 md:mx-2">
                          <a href={"/category/" + item.localMarketId}>
                            <button
                                id={`dropdownAvatarNameButton-${item.id}`}
                                onClick={() => toggleDropdown(index)}
                                className="flex items-center text-sm text-left pe-1 font-medium text-gray-900 rounded-full hover:text-red-600 dark:hover:text-red-500 md:me-0 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:text-white"
                                type="button"
                                style={{zIndex: 1}}
                            >
                              <span className="sr-only">Open user menu</span>
                              <img className="w-12 h-12 me-2 rounded-full" src={item.image} alt={item.name}/>
                              {item.name}
                            </button>
                          </a>
                        </div>
                    )
                ))}
              </div>
            </div>

            <hr className="h-px mx-24 bg-gray-300 border-0 rounded dark:bg-gray-700"></hr>
            <div className="flex items-center justify-center my-0.5 py-0.5">
              <div className="grid grid-cols-2 lg:grid-cols-3 place-items-left gap-1 py-3 md:px-6 w-3/4 md:w-1/2">
                {categories.map((item, index) => (

                    index > 17 && (
                        <div key={index} style={{position: 'relative'}} className="mx-1 md:mx-2">
                          <a href={"/category/"+ item.localMarketId}>
                            <button
                                id={`dropdownAvatarNameButton-${item.id}`}
                                onClick={() => toggleDropdown(index)}
                                className="flex items-center text-sm text-left pe-1 font-medium text-gray-900 rounded-full hover:text-red-600 dark:hover:text-red-500 md:me-0 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:text-white"
                                type="button"
                                style={{zIndex: 1}}
                            >
                              <span className="sr-only">Open user menu</span>
                              <img className="w-12 h-12 me-2 rounded-full" src={item.image} alt={item.name}/>
                              {item.name}
                            </button>
                          </a>
                        </div>
                    )
                ))}
              </div>
            </div>
          </div>
        </div>
      </>
  );
}

export default Category;
